module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.description != null && _vm.members != null) ? _c('div', [_c('header', [_c('pageTemplateProjectHeader')]), (_vm.description.content != null && _vm.members.content != null) ? _c('div', {
    staticClass: "pageBody"
  }, [_c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.renderText(_vm.description.content.acf.content, _vm.description.content.acf.contentEn))
    }
  }), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columnHeading",
    class: _vm.projectName
  }, [_c('h3', {
    staticClass: "columnTitle"
  }, [_vm._v(_vm._s(_vm.renderText('研究メンバー', 'MEMBER')))])]), _c('members', {
    attrs: {
      "html": _vm.renderText(_vm.members.content.acf.content, _vm.members.content.acf.contentEn)
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columnHeading",
    class: _vm.projectName
  }, [_c('h3', {
    staticClass: "columnTitle"
  }, [_vm._v(_vm._s(_vm.renderText('活動', 'ACTIVITY')))]), _c('router-link', {
    staticClass: "toPosts",
    attrs: {
      "to": _vm.toPosts('all')
    }
  }, [(_vm.projectNo < 4) ? _c('span', [_vm._v("0" + _vm._s(_vm.projectNo) + " ")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.renderText('活動 一覧へ', 'MORE')))])])]), _vm._l((_vm.latests), function(container) {
    return (container.content != null && container.content.length > 0) ? _c('latestPosts', {
      staticClass: "latest",
      attrs: {
        "container": container
      }
    }) : _vm._e()
  })], true)])]) : _vm._e(), (_vm.description.content == null || _vm.members.content == null) ? _c('spinner') : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65df9b1f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/about/pageTemplate.vue
// module id = 105
// module chunks = 1